// eslint-disable-next-line import/no-anonymous-default-export
export default html => ({ __html: html });
